import React from 'react';
import OrderFeedbackPanel from './OrderFeedbackPanel';
import { OrderFeedbackSummary } from '../../services/restaurantService';
import './OrderFeedback.css';

interface OrderFeedbackModalProps {
  appName: string;
  orderId: number;
  open: boolean;
  onClose: () => void;
  onSubmitted?: (summary: OrderFeedbackSummary) => void;
  onNotify?: (message: string, type: 'success' | 'error' | 'info') => void;
}

const OrderFeedbackModal: React.FC<OrderFeedbackModalProps> = ({
  appName,
  orderId,
  open,
  onClose,
  onSubmitted,
  onNotify,
}) => {
  if (!open) return null;

  return (
    <div className="order-feedback-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="feedback-modal-title">
      <div className="order-feedback-modal">
        <button type="button" className="order-feedback-modal-close" onClick={onClose} aria-label="Close">
          <i className="fa fa-times" aria-hidden />
        </button>
        <OrderFeedbackPanel
          appName={appName}
          orderId={orderId}
          onSubmitted={onSubmitted}
          onNotify={onNotify}
        />
      </div>
    </div>
  );
};

export default OrderFeedbackModal;
